var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Stone',{staticClass:"template-stone",attrs:{"gpv":_vm.gpv,"data-toggle":"tooltip","data-placement":"bottom","title":"Click to rotate, or drag to move"}})}
var staticRenderFns = []

export { render, staticRenderFns }